import React, { useContext, useEffect, useState } from "react";
import { Collapse, Select, Tooltip } from "antd";
import { AiFillCloseCircle } from "react-icons/ai";
import { GoDiffAdded } from "react-icons/go";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   addSMediaPostion,
//   addSocialMediaData,
// } from "../../Redux/Actions/CardAction";
// import companypfImage from "../../assests/img1/companyProfile_clss.svg";
// import { CardContext } from "../../store/CardContext";

const { Panel } = Collapse;
const Forms = () => {
  // const { socialMediaDetails, SMediaPostion } = useSelector( (state) => state.cardReducer );

  // const adInitialValues = SMediaPostion?.pos1
  //   ? [
  //     SMediaPostion?.pos1 ? SMediaPostion.pos1 : "",
  //     SMediaPostion?.pos2 ? SMediaPostion.pos2 : "",
  //     SMediaPostion?.pos3 ? SMediaPostion.pos3 : "",
  //     SMediaPostion?.pos4 ? SMediaPostion.pos4 : "",
  //     SMediaPostion?.pos5 ? SMediaPostion.pos5 : "",
  //     SMediaPostion?.pos6 ? SMediaPostion.pos6 : "",
  //     SMediaPostion?.pos7 ? SMediaPostion.pos7 : "",
  //     SMediaPostion?.pos8 ? SMediaPostion.pos8 : "",
  //     SMediaPostion?.pos9 ? SMediaPostion.pos9 : "",
  //     SMediaPostion?.pos10 ? SMediaPostion.pos10 : "",
  //   ]
  //   : [];

  // const initialValues = {
  //   facebook: socialMediaDetails?.facebook,
  //   instagram: socialMediaDetails?.instagram,
  //   whatsappNumber: socialMediaDetails?.whatsappNumber,
  //   linkedin: socialMediaDetails?.linkedin,
  //   twitter: socialMediaDetails?.twitter,
  //   youtube: socialMediaDetails?.youtube,
  //   tiktok: socialMediaDetails?.tiktok,
  //   snapchat: socialMediaDetails?.snapchat,
  //   skype: socialMediaDetails?.skype,
  //   companyProfile: socialMediaDetails?.companyProfile,
  // };
  // const dispatch = useDispatch();
  // const [socialMediaData, setSocialMediaData] = useContext(CardContext);
  const [socialMediaData, setSocialMediaData] = useState('');
  const [socialMediaDetails, setSocialMediaDetails] = useState('');     //for demo only
  // const [userContextData, setUserContextData] = useContext(CardContext)

  // useEffect(() => {
  //   setSocialMediaData({
  //     facebook: userContextData?.facebook,
  //     instagram: userContextData?.instagram,
  //     whatsappNumber: userContextData?.whatsappNumber,
  //     linkedin: userContextData?.linkedin,
  //     twitter: userContextData?.twitter,
  //     youtube: userContextData?.youtube,
  //     tiktok: userContextData?.tiktok,
  //     snapchat: userContextData?.snapchat,
  //     skype: userContextData?.skype,
  //     companyProfile: userContextData?.companyProfile,
  //   })
  // }, [userContextData])
  const [sm, setSM] = useState("facebook");
  // const [ad, setAd] = useState(
  //   adInitialValues.filter((adInitialValues) => adInitialValues !== "")
  // );

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSocialMediaData({ ...socialMediaData, [name]: value });
  };
  const handleChangeSM = (value) => {
    setSM(value);
  };
  const [ad,setAd] = useState([])

  const handleChangeAd = () => {
    setAd((ad) => [...ad, sm]);
  };

  const handleRemove = (Id) => {
    setAd(ad.filter((ad) => ad !== Id));
  };

  // useEffect(() => {
  //   dispatch(addSocialMediaData(socialMediaData));
  // }, [socialMediaData]);

  //--------------------------------------------------facebook1
  const facebook1 = (

    <div className="flex justify-center rounded-lg bg-gray-200 border text-gray-900  min-w-0 w-full text-sm border-gray-300 p-2.5  ">
      <svg
        aria-hidden="true"
        className="w-5 h-5 text-blue-500 dark:text-blue-400 mr-1"
        fill="currentColor"
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951z" />
      </svg>
     <p> Facebook</p>
    </div>

  );

  //--------------------------------------------------instagram1
  const instagram1 = (

    <div className="flex justify-center rounded-lg bg-gray-200 border text-gray-900   min-w-0 w-full text-sm border-gray-300 p-2.5  ">
      <svg
        aria-hidden="true"
        className="w-5 h-5 text-pink-500 dark:text-pink-500 mr-1"
        fill="currentColor"
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.917 3.917 0 0 0-1.417.923A3.927 3.927 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.916 3.916 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.926 3.926 0 0 0-.923-1.417A3.911 3.911 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0h.003zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599.28.28.453.546.598.92.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.47 2.47 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.478 2.478 0 0 1-.92-.598 2.48 2.48 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233 0-2.136.008-2.388.046-3.231.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92.28-.28.546-.453.92-.598.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045v.002zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92zm-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217zm0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334z" />
      </svg>
      Instagram
    </div>

  );

  //--------------------------------------------------whatsappNumber1
  const whatsappNumber1 = (

    <div className="flex justify-center rounded-lg bg-gray-200 border text-gray-900   min-w-0 w-full text-sm border-gray-300 p-2.5  ">
      <svg
        aria-hidden="true"
        className="w-5 h-5 text-green-500 dark:text-green-400 mr-1"
        fill="currentColor"
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z" />
      </svg>
      Whatsapp
    </div>

  );

  //--------------------------------------------------linkedin1
  const linkedin1 = (

    <div className="flex justify-center rounded-lg bg-gray-200 border text-gray-900   min-w-0 w-full text-sm border-gray-300 p-2.5  ">
      <svg
        aria-hidden="true"
        className="w-5 h-5 text-blue-500 mr-1"
        fill="currentColor"
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854V1.146zm4.943 12.248V6.169H2.542v7.225h2.401zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248-.822 0-1.359.54-1.359 1.248 0 .694.521 1.248 1.327 1.248h.016zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016a5.54 5.54 0 0 1 .016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225h2.4z" />
      </svg>
      Linkedin
    </div>

  );

  //--------------------------------------------------companyProfile1
  const companyProfile1 = (

    <div className="flex justify-center rounded-lg bg-gray-200 border text-gray-900   min-w-0 w-full text-sm border-gray-300 p-2.5  ">
      {/* <img className="w-6" src={companypfImage} alt="" /> */}

      Company Profile
    </div>

  );

  //--------------------------------------------------twitter1
  const twitter1 = (

    <div className="flex justify-center rounded-lg bg-gray-200 border text-gray-900   min-w-0 w-full text-sm border-gray-300 p-2.5  ">
      <svg width="20" height="20" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M36.4097 4.5H43.0257L28.5717 21.02L45.5757 43.5H32.2597L21.8317 29.866L9.89969 43.5H3.27969L18.7397 25.83L2.42969 4.5H16.0797L25.5057 16.962L36.4057 4.5H36.4097ZM34.0877 39.54H37.7537L14.0897 8.252H10.1557L34.0877 39.54Z" fill="black" />
      </svg>

      X( Twitter)
    </div>

  );

  //--------------------------------------------------youtube1
  const youtube1 = (

    <div className="flex justify-center rounded-lg bg-gray-200 border text-gray-900   min-w-0 w-full text-sm border-gray-300 p-2.5  ">
      <svg
        aria-hidden="true"
        className="w-5 h-5 text-red-500 mr-1"
        fill="currentColor"
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M8.051 1.999h.089c.822.003 4.987.033 6.11.335a2.01 2.01 0 0 1 1.415 1.42c.101.38.172.883.22 1.402l.01.104.022.26.008.104c.065.914.073 1.77.074 1.957v.075c-.001.194-.01 1.108-.082 2.06l-.008.105-.009.104c-.05.572-.124 1.14-.235 1.558a2.007 2.007 0 0 1-1.415 1.42c-1.16.312-5.569.334-6.18.335h-.142c-.309 0-1.587-.006-2.927-.052l-.17-.006-.087-.004-.171-.007-.171-.007c-1.11-.049-2.167-.128-2.654-.26a2.007 2.007 0 0 1-1.415-1.419c-.111-.417-.185-.986-.235-1.558L.09 9.82l-.008-.104A31.4 31.4 0 0 1 0 7.68v-.123c.002-.215.01-.958.064-1.778l.007-.103.003-.052.008-.104.022-.26.01-.104c.048-.519.119-1.023.22-1.402a2.007 2.007 0 0 1 1.415-1.42c.487-.13 1.544-.21 2.654-.26l.17-.007.172-.006.086-.003.171-.007A99.788 99.788 0 0 1 7.858 2h.193zM6.4 5.209v4.818l4.157-2.408L6.4 5.209z" />
      </svg>
      Youtube
    </div>

  );



  //--------------------------------------------------tiktok1
  const tiktok1 = (

    <div className="flex justify-center rounded-lg bg-gray-200 border text-gray-900   min-w-0 w-full text-sm border-gray-300 p-2.5  ">
      <svg
        aria-hidden="true"
        className="w-5 h-5 text-black-500 mr-1"
        fill="currentColor"
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M9 0h1.98c.144.715.54 1.617 1.235 2.512C12.895 3.389 13.797 4 15 4v2c-1.753 0-3.07-.814-4-1.829V11a5 5 0 1 1-5-5v2a3 3 0 1 0 3 3V0Z" />{" "}
      </svg>
      Tiktok
    </div>

  );

  //--------------------------------------------------snapchat1
  const snapchat1 = (

    <div className="flex justify-center rounded-lg bg-gray-200 border text-gray-900  min-w-0 w-full text-sm border-gray-300 p-2.5  ">
      <svg
        aria-hidden="true"
        className="w-5 h-5 text-yellow-500 mr-1"
        fill="currentColor"
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M15.943 11.526c-.111-.303-.323-.465-.564-.599a1.416 1.416 0 0 0-.123-.064l-.219-.111c-.752-.399-1.339-.902-1.746-1.498a3.387 3.387 0 0 1-.3-.531c-.034-.1-.032-.156-.008-.207a.338.338 0 0 1 .097-.1c.129-.086.262-.173.352-.231.162-.104.289-.187.371-.245.309-.216.525-.446.66-.702a1.397 1.397 0 0 0 .069-1.16c-.205-.538-.713-.872-1.329-.872a1.829 1.829 0 0 0-.487.065c.006-.368-.002-.757-.035-1.139-.116-1.344-.587-2.048-1.077-2.61a4.294 4.294 0 0 0-1.095-.881C9.764.216 8.92 0 7.999 0c-.92 0-1.76.216-2.505.641-.412.232-.782.53-1.097.883-.49.562-.96 1.267-1.077 2.61-.033.382-.04.772-.036 1.138a1.83 1.83 0 0 0-.487-.065c-.615 0-1.124.335-1.328.873a1.398 1.398 0 0 0 .067 1.161c.136.256.352.486.66.701.082.058.21.14.371.246l.339.221a.38.38 0 0 1 .109.11c.026.053.027.11-.012.217a3.363 3.363 0 0 1-.295.52c-.398.583-.968 1.077-1.696 1.472-.385.204-.786.34-.955.8-.128.348-.044.743.28 1.075.119.125.257.23.409.31a4.43 4.43 0 0 0 1 .4.66.66 0 0 1 .202.09c.118.104.102.26.259.488.079.118.18.22.296.3.33.229.701.243 1.095.258.355.014.758.03 1.217.18.19.064.389.186.618.328.55.338 1.305.802 2.566.802 1.262 0 2.02-.466 2.576-.806.227-.14.424-.26.609-.321.46-.152.863-.168 1.218-.181.393-.015.764-.03 1.095-.258a1.14 1.14 0 0 0 .336-.368c.114-.192.11-.327.217-.42a.625.625 0 0 1 .19-.087 4.446 4.446 0 0 0 1.014-.404c.16-.087.306-.2.429-.336l.004-.005c.304-.325.38-.709.256-1.047Zm-1.121.602c-.684.378-1.139.337-1.493.565-.3.193-.122.61-.34.76-.269.186-1.061-.012-2.085.326-.845.279-1.384 1.082-2.903 1.082-1.519 0-2.045-.801-2.904-1.084-1.022-.338-1.816-.14-2.084-.325-.218-.15-.041-.568-.341-.761-.354-.228-.809-.187-1.492-.563-.436-.24-.189-.39-.044-.46 2.478-1.199 2.873-3.05 2.89-3.188.022-.166.045-.297-.138-.466-.177-.164-.962-.65-1.18-.802-.36-.252-.52-.503-.402-.812.082-.214.281-.295.49-.295a.93.93 0 0 1 .197.022c.396.086.78.285 1.002.338.027.007.054.01.082.011.118 0 .16-.06.152-.195-.026-.433-.087-1.277-.019-2.066.094-1.084.444-1.622.859-2.097.2-.229 1.137-1.22 2.93-1.22 1.792 0 2.732.987 2.931 1.215.416.475.766 1.013.859 2.098.068.788.009 1.632-.019 2.065-.01.142.034.195.152.195a.35.35 0 0 0 .082-.01c.222-.054.607-.253 1.002-.338a.912.912 0 0 1 .197-.023c.21 0 .409.082.49.295.117.309-.04.56-.401.812-.218.152-1.003.638-1.18.802-.184.169-.16.3-.139.466.018.14.413 1.991 2.89 3.189.147.073.394.222-.041.464Z" />{" "}
      </svg>
      Snapchat
    </div>

  );

  //--------------------------------------------------skype1
  const skype1 = (

    <div className="flex justify-center rounded-lg bg-gray-200 border text-gray-900  min-w-0 w-full text-sm border-gray-300 p-2.5  ">
      <svg
        aria-hidden="true"
        className="w-5 h-5 text-blue-500 mr-1"
        fill="currentColor"
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M4.671 0c.88 0 1.733.247 2.468.702a7.423 7.423 0 0 1 6.02 2.118 7.372 7.372 0 0 1 2.167 5.215c0 .344-.024.687-.072 1.026a4.662 4.662 0 0 1 .6 2.281 4.645 4.645 0 0 1-1.37 3.294A4.673 4.673 0 0 1 11.18 16c-.84 0-1.658-.226-2.37-.644a7.423 7.423 0 0 1-6.114-2.107A7.374 7.374 0 0 1 .529 8.035c0-.363.026-.724.08-1.081a4.644 4.644 0 0 1 .76-5.59A4.68 4.68 0 0 1 4.67 0zm.447 7.01c.18.309.43.572.729.769a7.07 7.07 0 0 0 1.257.653c.492.205.873.38 1.145.523.229.112.437.264.615.448.135.142.21.331.21.528a.872.872 0 0 1-.335.723c-.291.196-.64.289-.99.264a2.618 2.618 0 0 1-1.048-.206 11.44 11.44 0 0 1-.532-.253 1.284 1.284 0 0 0-.587-.15.717.717 0 0 0-.501.176.63.63 0 0 0-.195.491.796.796 0 0 0 .148.482 1.2 1.2 0 0 0 .456.354 5.113 5.113 0 0 0 2.212.419 4.554 4.554 0 0 0 1.624-.265 2.296 2.296 0 0 0 1.08-.801c.267-.39.402-.855.386-1.327a2.09 2.09 0 0 0-.279-1.101 2.53 2.53 0 0 0-.772-.792A7.198 7.198 0 0 0 8.486 7.3a1.05 1.05 0 0 0-.145-.058 18.182 18.182 0 0 1-1.013-.447 1.827 1.827 0 0 1-.54-.387.727.727 0 0 1-.2-.508.805.805 0 0 1 .385-.723 1.76 1.76 0 0 1 .968-.247c.26-.003.52.03.772.096.274.079.542.177.802.293.105.049.22.075.336.076a.6.6 0 0 0 .453-.19.69.69 0 0 0 .18-.496.717.717 0 0 0-.17-.476 1.374 1.374 0 0 0-.556-.354 3.69 3.69 0 0 0-.708-.183 5.963 5.963 0 0 0-1.022-.078 4.53 4.53 0 0 0-1.536.258 2.71 2.71 0 0 0-1.174.784 1.91 1.91 0 0 0-.45 1.287c-.01.37.076.736.25 1.063z" />{" "}
      </svg>
      Skype
    </div>

  );

  //--------------------------------------------------
  const facebook = (
    <div class="flex ">
      <span className="inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border border-r-0 border-gray-300 rounded-l-md ">
        <svg
          aria-hidden="true"
          className="w-5 h-5 text-blue-500 dark:text-blue-400"
          fill="currentColor"
          viewBox="0 0 16 16"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951z" />
        </svg>
      </span>
      <input
        type="text"
        name="facebook"
        className="rounded-none rounded-r-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5  "
        placeholder=""
        onChange={handleChange}
        // value={socialMediaData["facebook"] || ""}
        value={socialMediaDetails?.facebook || ""}
      />
    </div>
  );
  //--------------------------------------------------
  const instagram = (
    <div class="flex">
      <span className="inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border border-r-0 border-gray-300 rounded-l-md ">
        <svg
          aria-hidden="true"
          className="w-5 h-5 text-pink-500 dark:text-pink-500"
          fill="currentColor"
          viewBox="0 0 16 16"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.917 3.917 0 0 0-1.417.923A3.927 3.927 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.916 3.916 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.926 3.926 0 0 0-.923-1.417A3.911 3.911 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0h.003zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599.28.28.453.546.598.92.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.47 2.47 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.478 2.478 0 0 1-.92-.598 2.48 2.48 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233 0-2.136.008-2.388.046-3.231.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92.28-.28.546-.453.92-.598.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045v.002zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92zm-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217zm0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334z" />
        </svg>
      </span>
      <input
        type="text"
        name="instagram"
        className="rounded-none rounded-r-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5  "
        placeholder=""
        onChange={handleChange}
        // value={socialMediaData["instagram"] || ""}
        value={socialMediaDetails?.instagram || ""}
      />
    </div>
  );
  //--------------------------------------------------
  const whatsappNumber = (
    <div class="flex">
      <span className="inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border border-r-0 border-gray-300 rounded-l-md ">
        <svg
          aria-hidden="true"
          className="w-5 h-5 text-green-500 dark:text-green-400"
          fill="currentColor"
          viewBox="0 0 16 16"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z" />
        </svg>
      </span>
      <input
        type="text"
        name="whatsappNumber"
        className="rounded-none rounded-r-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5  "
        placeholder=""
        onChange={handleChange}
        // value={socialMediaData["whatsappNumber"] || ""}
        value={socialMediaDetails?.whatsappNumber || ""}
      />
    </div>
  );
  //--------------------------------------------------
  const linkedin = (
    <div class="flex">
      <span className="inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border border-r-0 border-gray-300 rounded-l-md ">
        <svg
          aria-hidden="true"
          className="w-5 h-5 text-blue-500 "
          fill="currentColor"
          viewBox="0 0 16 16"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854V1.146zm4.943 12.248V6.169H2.542v7.225h2.401zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248-.822 0-1.359.54-1.359 1.248 0 .694.521 1.248 1.327 1.248h.016zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016a5.54 5.54 0 0 1 .016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225h2.4z" />
        </svg>
      </span>
      <input
        type="text"
        name="linkedin"
        className="rounded-none rounded-r-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5  "
        placeholder=""
        onChange={handleChange}
        // value={socialMediaData["linkedin"] || ""}
        value={socialMediaDetails?.linkedin || ""}
      />
    </div>
  );
  //--------------------------------------------------
  const companyProfile = (
    <div class="flex">
      <span className="inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border border-r-0 border-gray-300 rounded-l-md ">
        {/* <img className="w-6" src={companypfImage} alt="" /> */}
      </span>
      <input
        type="text"
        name="companyProfile"
        className="rounded-none rounded-r-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5  "
        placeholder=""
        onChange={handleChange}
        // value={socialMediaData["skype"] || ""}
        value={socialMediaDetails?.companyProfile || ""}
      />
    </div>
  );
  //--------------------------------------------------
  const twitter = (
    <div class="flex">
      <span className="inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border border-r-0 border-gray-300 rounded-l-md ">
        <svg width="20" height="20" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M36.4097 4.5H43.0257L28.5717 21.02L45.5757 43.5H32.2597L21.8317 29.866L9.89969 43.5H3.27969L18.7397 25.83L2.42969 4.5H16.0797L25.5057 16.962L36.4057 4.5H36.4097ZM34.0877 39.54H37.7537L14.0897 8.252H10.1557L34.0877 39.54Z" fill="black" />
        </svg>

      </span>
      <input
        type="text"
        name="twitter"
        className="rounded-none rounded-r-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5  "
        placeholder=""
        onChange={handleChange}
        // value={socialMediaData["twitter"] || ""}
        value={socialMediaDetails?.twitter || ""}
      />
    </div>
  );
  //--------------------------------------------------
  const youtube = (
    <div class="flex">
      <span className="inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border border-r-0 border-gray-300 rounded-l-md ">
        <svg
          aria-hidden="true"
          className="w-5 h-5 text-red-500 "
          fill="currentColor"
          viewBox="0 0 16 16"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M8.051 1.999h.089c.822.003 4.987.033 6.11.335a2.01 2.01 0 0 1 1.415 1.42c.101.38.172.883.22 1.402l.01.104.022.26.008.104c.065.914.073 1.77.074 1.957v.075c-.001.194-.01 1.108-.082 2.06l-.008.105-.009.104c-.05.572-.124 1.14-.235 1.558a2.007 2.007 0 0 1-1.415 1.42c-1.16.312-5.569.334-6.18.335h-.142c-.309 0-1.587-.006-2.927-.052l-.17-.006-.087-.004-.171-.007-.171-.007c-1.11-.049-2.167-.128-2.654-.26a2.007 2.007 0 0 1-1.415-1.419c-.111-.417-.185-.986-.235-1.558L.09 9.82l-.008-.104A31.4 31.4 0 0 1 0 7.68v-.123c.002-.215.01-.958.064-1.778l.007-.103.003-.052.008-.104.022-.26.01-.104c.048-.519.119-1.023.22-1.402a2.007 2.007 0 0 1 1.415-1.42c.487-.13 1.544-.21 2.654-.26l.17-.007.172-.006.086-.003.171-.007A99.788 99.788 0 0 1 7.858 2h.193zM6.4 5.209v4.818l4.157-2.408L6.4 5.209z" />
        </svg>
      </span>
      <input
        type="text"
        name="youtube"
        className="rounded-none rounded-r-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5  "
        placeholder=""
        onChange={handleChange}
        // value={socialMediaData["youtube"] || ""}
        value={socialMediaDetails?.youtube || ""}
      />
    </div>
  );
  //--------------------------------------------------
  const tiktok = (
    <div class="flex">
      <span className="inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border border-r-0 border-gray-300 rounded-l-md ">
        <svg
          aria-hidden="true"
          className="w-5 h-5 text-black-500 "
          fill="currentColor"
          viewBox="0 0 16 16"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M9 0h1.98c.144.715.54 1.617 1.235 2.512C12.895 3.389 13.797 4 15 4v2c-1.753 0-3.07-.814-4-1.829V11a5 5 0 1 1-5-5v2a3 3 0 1 0 3 3V0Z" />{" "}
        </svg>
      </span>
      <input
        type="text"
        name="tiktok"
        className="rounded-none rounded-r-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5  "
        placeholder=""
        onChange={handleChange}
        // value={socialMediaData["tiktok"] || ""}
        value={socialMediaDetails?.tiktok || ""}
      />
    </div>
  );
  //--------------------------------------------------
  const snapchat = (
    <div class="flex">
      <span className="inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border border-r-0 border-gray-300 rounded-l-md ">
        <svg
          aria-hidden="true"
          className="w-5 h-5 text-yellow-500 "
          fill="currentColor"
          viewBox="0 0 16 16"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M15.943 11.526c-.111-.303-.323-.465-.564-.599a1.416 1.416 0 0 0-.123-.064l-.219-.111c-.752-.399-1.339-.902-1.746-1.498a3.387 3.387 0 0 1-.3-.531c-.034-.1-.032-.156-.008-.207a.338.338 0 0 1 .097-.1c.129-.086.262-.173.352-.231.162-.104.289-.187.371-.245.309-.216.525-.446.66-.702a1.397 1.397 0 0 0 .069-1.16c-.205-.538-.713-.872-1.329-.872a1.829 1.829 0 0 0-.487.065c.006-.368-.002-.757-.035-1.139-.116-1.344-.587-2.048-1.077-2.61a4.294 4.294 0 0 0-1.095-.881C9.764.216 8.92 0 7.999 0c-.92 0-1.76.216-2.505.641-.412.232-.782.53-1.097.883-.49.562-.96 1.267-1.077 2.61-.033.382-.04.772-.036 1.138a1.83 1.83 0 0 0-.487-.065c-.615 0-1.124.335-1.328.873a1.398 1.398 0 0 0 .067 1.161c.136.256.352.486.66.701.082.058.21.14.371.246l.339.221a.38.38 0 0 1 .109.11c.026.053.027.11-.012.217a3.363 3.363 0 0 1-.295.52c-.398.583-.968 1.077-1.696 1.472-.385.204-.786.34-.955.8-.128.348-.044.743.28 1.075.119.125.257.23.409.31a4.43 4.43 0 0 0 1 .4.66.66 0 0 1 .202.09c.118.104.102.26.259.488.079.118.18.22.296.3.33.229.701.243 1.095.258.355.014.758.03 1.217.18.19.064.389.186.618.328.55.338 1.305.802 2.566.802 1.262 0 2.02-.466 2.576-.806.227-.14.424-.26.609-.321.46-.152.863-.168 1.218-.181.393-.015.764-.03 1.095-.258a1.14 1.14 0 0 0 .336-.368c.114-.192.11-.327.217-.42a.625.625 0 0 1 .19-.087 4.446 4.446 0 0 0 1.014-.404c.16-.087.306-.2.429-.336l.004-.005c.304-.325.38-.709.256-1.047Zm-1.121.602c-.684.378-1.139.337-1.493.565-.3.193-.122.61-.34.76-.269.186-1.061-.012-2.085.326-.845.279-1.384 1.082-2.903 1.082-1.519 0-2.045-.801-2.904-1.084-1.022-.338-1.816-.14-2.084-.325-.218-.15-.041-.568-.341-.761-.354-.228-.809-.187-1.492-.563-.436-.24-.189-.39-.044-.46 2.478-1.199 2.873-3.05 2.89-3.188.022-.166.045-.297-.138-.466-.177-.164-.962-.65-1.18-.802-.36-.252-.52-.503-.402-.812.082-.214.281-.295.49-.295a.93.93 0 0 1 .197.022c.396.086.78.285 1.002.338.027.007.054.01.082.011.118 0 .16-.06.152-.195-.026-.433-.087-1.277-.019-2.066.094-1.084.444-1.622.859-2.097.2-.229 1.137-1.22 2.93-1.22 1.792 0 2.732.987 2.931 1.215.416.475.766 1.013.859 2.098.068.788.009 1.632-.019 2.065-.01.142.034.195.152.195a.35.35 0 0 0 .082-.01c.222-.054.607-.253 1.002-.338a.912.912 0 0 1 .197-.023c.21 0 .409.082.49.295.117.309-.04.56-.401.812-.218.152-1.003.638-1.18.802-.184.169-.16.3-.139.466.018.14.413 1.991 2.89 3.189.147.073.394.222-.041.464Z" />{" "}
        </svg>
      </span>
      <input
        type="text"
        name="snapchat"
        className="rounded-none rounded-r-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5  "
        placeholder=""
        onChange={handleChange}
        // value={socialMediaData["snapchat"] || ""}
        value={socialMediaDetails?.snapchat || ""}
      />
    </div>
  );
  //--------------------------------------------------
  const skype = (
    <div class="flex">
      <span className="inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border border-r-0 border-gray-300 rounded-l-md ">
        <svg
          aria-hidden="true"
          className="w-5 h-5 text-blue-500 "
          fill="currentColor"
          viewBox="0 0 16 16"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M4.671 0c.88 0 1.733.247 2.468.702a7.423 7.423 0 0 1 6.02 2.118 7.372 7.372 0 0 1 2.167 5.215c0 .344-.024.687-.072 1.026a4.662 4.662 0 0 1 .6 2.281 4.645 4.645 0 0 1-1.37 3.294A4.673 4.673 0 0 1 11.18 16c-.84 0-1.658-.226-2.37-.644a7.423 7.423 0 0 1-6.114-2.107A7.374 7.374 0 0 1 .529 8.035c0-.363.026-.724.08-1.081a4.644 4.644 0 0 1 .76-5.59A4.68 4.68 0 0 1 4.67 0zm.447 7.01c.18.309.43.572.729.769a7.07 7.07 0 0 0 1.257.653c.492.205.873.38 1.145.523.229.112.437.264.615.448.135.142.21.331.21.528a.872.872 0 0 1-.335.723c-.291.196-.64.289-.99.264a2.618 2.618 0 0 1-1.048-.206 11.44 11.44 0 0 1-.532-.253 1.284 1.284 0 0 0-.587-.15.717.717 0 0 0-.501.176.63.63 0 0 0-.195.491.796.796 0 0 0 .148.482 1.2 1.2 0 0 0 .456.354 5.113 5.113 0 0 0 2.212.419 4.554 4.554 0 0 0 1.624-.265 2.296 2.296 0 0 0 1.08-.801c.267-.39.402-.855.386-1.327a2.09 2.09 0 0 0-.279-1.101 2.53 2.53 0 0 0-.772-.792A7.198 7.198 0 0 0 8.486 7.3a1.05 1.05 0 0 0-.145-.058 18.182 18.182 0 0 1-1.013-.447 1.827 1.827 0 0 1-.54-.387.727.727 0 0 1-.2-.508.805.805 0 0 1 .385-.723 1.76 1.76 0 0 1 .968-.247c.26-.003.52.03.772.096.274.079.542.177.802.293.105.049.22.075.336.076a.6.6 0 0 0 .453-.19.69.69 0 0 0 .18-.496.717.717 0 0 0-.17-.476 1.374 1.374 0 0 0-.556-.354 3.69 3.69 0 0 0-.708-.183 5.963 5.963 0 0 0-1.022-.078 4.53 4.53 0 0 0-1.536.258 2.71 2.71 0 0 0-1.174.784 1.91 1.91 0 0 0-.45 1.287c-.01.37.076.736.25 1.063z" />{" "}
        </svg>
      </span>
      <input
        type="text"
        name="skype"
        className="rounded-none rounded-r-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5  "
        placeholder=""
        onChange={handleChange}
        // value={socialMediaData["skype"] || ""}
        value={socialMediaDetails?.skype || ""}
      />
    </div>
  );
  //--------------------------------------------------
  const postion = {
    pos1: ad[0],
    pos2: ad[1],
    pos3: ad[2],
    pos4: ad[3],
    pos5: ad[4],
    pos6: ad[5],
    pos7: ad[6],
    pos8: ad[7],
    pos9: ad[8],
    pos10: ad[9],
  };
  // useEffect(() => {
  //   dispatch(addSMediaPostion(postion));
  // }, [ad]);
  //--------------------------------------------------
  return (
    <div>
      <div className="flex gap-3  mb-4 ">
        <div >
          <Select
            defaultValue="lucy"
            size='large'
            value={sm}
            style={{
              width: 130,
            }}
            onChange={handleChangeSM}
            options={[
              {
                value: "facebook",
                label: "Facebook",
                disabled:
                  sm === "facebook" ||
                    ad[0] === "facebook" ||
                    ad[1] === "facebook" ||
                    ad[2] === "facebook" ||
                    ad[3] === "facebook" ||
                    ad[4] === "facebook" ||
                    ad[5] === "facebook" ||
                    ad[6] === "facebook" ||
                    ad[7] === "facebook" ||
                    ad[8] === "facebook" ||
                    ad[9] === "facebook"
                    ? true
                    : false,
              },
              {
                value: "instagram",
                label: "Instagram",

                disabled:
                  sm === "instagram" ||
                    ad[0] === "instagram" ||
                    ad[1] === "instagram" ||
                    ad[2] === "instagram" ||
                    ad[3] === "instagram" ||
                    ad[4] === "instagram" ||
                    ad[5] === "instagram" ||
                    ad[6] === "instagram" ||
                    ad[7] === "instagram" ||
                    ad[8] === "instagram" ||
                    ad[9] === "instagram"
                    ? true
                    : false,
              },

              {
                value: "whatsappNumber",
                label: "Whatsapp",

                disabled:
                  sm === "whatsappNumber" ||
                    ad[0] === "whatsappNumber" ||
                    ad[1] === "whatsappNumber" ||
                    ad[2] === "whatsappNumber" ||
                    ad[3] === "whatsappNumber" ||
                    ad[4] === "whatsappNumber" ||
                    ad[5] === "whatsappNumber" ||
                    ad[6] === "whatsappNumber" ||
                    ad[7] === "whatsappNumber" ||
                    ad[8] === "whatsappNumber" ||
                    ad[9] === "whatsappNumber"
                    ? true
                    : false,
              },
              {
                value: "linkedin",

                label: "Linkedin",
                disabled:
                  sm === "linkedin" ||
                    ad[0] === "linkedin" ||
                    ad[1] === "linkedin" ||
                    ad[2] === "linkedin" ||
                    ad[3] === "linkedin" ||
                    ad[4] === "linkedin" ||
                    ad[5] === "linkedin" ||
                    ad[6] === "linkedin" ||
                    ad[7] === "linkedin" ||
                    ad[8] === "linkedin" ||
                    ad[9] === "linkedin"
                    ? true
                    : false,
              },
              {
                value: "companyProfile",

                label: "Company Profile",
                disabled:
                  sm === "companyProfile" ||
                    ad[0] === "companyProfile" ||
                    ad[1] === "companyProfile" ||
                    ad[2] === "companyProfile" ||
                    ad[3] === "companyProfile" ||
                    ad[4] === "companyProfile" ||
                    ad[5] === "companyProfile" ||
                    ad[6] === "companyProfile" ||
                    ad[7] === "companyProfile" ||
                    ad[8] === "companyProfile" ||
                    ad[9] === "companyProfile"
                    ? true
                    : false,
              },
              {
                value: "twitter",
                label: "X(Twitter)",
                disabled:
                  sm === "twitter" ||
                    ad[0] === "twitter" ||
                    ad[1] === "twitter" ||
                    ad[2] === "twitter" ||
                    ad[3] === "twitter" ||
                    ad[4] === "twitter" ||
                    ad[5] === "twitter" ||
                    ad[6] === "twitter" ||
                    ad[7] === "twitter" ||
                    ad[8] === "twitter" ||
                    ad[9] === "twitter"
                    ? true
                    : false,
              },
              {
                value: "youtube",

                label: "Youtube",
                disabled:
                  sm === "youtube" ||
                    ad[0] === "youtube" ||
                    ad[1] === "youtube" ||
                    ad[2] === "youtube" ||
                    ad[3] === "youtube" ||
                    ad[4] === "youtube" ||
                    ad[5] === "youtube" ||
                    ad[6] === "youtube" ||
                    ad[7] === "youtube" ||
                    ad[8] === "youtube" ||
                    ad[9] === "youtube"
                    ? true
                    : false,
              },
              {
                value: "tiktok",
                label: "Tiktok",
                disabled:
                  sm === "tiktok" ||
                    ad[0] === "tiktok" ||
                    ad[1] === "tiktok" ||
                    ad[2] === "tiktok" ||
                    ad[3] === "tiktok" ||
                    ad[4] === "tiktok" ||
                    ad[5] === "tiktok" ||
                    ad[6] === "tiktok" ||
                    ad[7] === "tiktok" ||
                    ad[8] === "tiktok" ||
                    ad[9] === "tiktok"
                    ? true
                    : false,
              },

              {
                value: "snapchat",
                label: "Snapchat",

                disabled:
                  sm === "snapchat" ||
                    ad[0] === "snapchat" ||
                    ad[1] === "snapchat" ||
                    ad[2] === "snapchat" ||
                    ad[3] === "snapchat" ||
                    ad[4] === "snapchat" ||
                    ad[5] === "snapchat" ||
                    ad[6] === "snapchat" ||
                    ad[7] === "snapchat" ||
                    ad[8] === "snapchat" ||
                    ad[9] === "snapchat"
                    ? true
                    : false,
              },
              {
                value: "skype",
                label: "skype",
                disabled:
                  sm === "skype" ||
                    ad[0] === "skype" ||
                    ad[1] === "skype" ||
                    ad[2] === "skype" ||
                    ad[3] === "skype" ||
                    ad[4] === "skype" ||
                    ad[5] === "skype" ||
                    ad[6] === "skype" ||
                    ad[7] === "skype" ||
                    ad[8] === "skype" ||
                    ad[9] === "skype"
                    ? true
                    : false,
              },
            ]}
          />
        </div>
        <div className="w-[262px] ">
          {sm === "facebook"
            ? facebook1
            : sm === "instagram"
              ? instagram1
              : sm === "whatsappNumber"
                ? whatsappNumber1
                : sm === "linkedin"
                  ? linkedin1
                  : sm === "twitter"
                    ? twitter1
                    : sm === "youtube"
                      ? youtube1
                      : sm === "tiktok"
                        ? tiktok1
                        : sm === "snapchat"
                          ? snapchat1
                          : sm === "skype"
                            ? skype1
                            : sm === "companyProfile"
                              ? companyProfile1
                              : facebook1}
        </div>
        <div>
          {ad.includes(sm) ? (
            <Tooltip placement="top" title="Already Added">
              <button
                className="text-red-500 ml-[12px] text-[36px] disabled:opacity-75 cursor-not-allowed "
                disabled

                onClick={handleChangeAd}
              >
                {/* <GoDiffAdded /> */}
                <p>+</p>
              </button>{" "}
            </Tooltip>
          ) : (
            <div
              style={{
                color: "green ",
                // size: "60px",
                // marginTop: "5px",
                marginLeft: '12px',
                fontSize: "36px",
                cursor: "pointer",
              }}
              onClick={handleChangeAd}
            >
              {/* <GoDiffAdded /> */}
              <p>+</p>
            </div>
          )}
        </div>
      </div>
      <div className="grid gap-6 mb-4 md:grid-cols-5">
        <div className="col-span-4">
          {ad[0] === "facebook"
            ? facebook
            : ad[0] === "instagram"
              ? instagram
              : ad[0] === "whatsappNumber"
                ? whatsappNumber
                : ad[0] === "linkedin"
                  ? linkedin
                  : ad[0] === "twitter"
                    ? twitter
                    : ad[0] === "youtube"
                      ? youtube
                      : ad[0] === "tiktok"
                        ? tiktok
                        : ad[0] === "snapchat"
                          ? snapchat
                          : ad[0] === "skype"
                            ? skype
                            : ad[0] === "companyProfile"
                              ? companyProfile
                              : ""}
        </div>
        {ad.length > 0 ? (
          // <button
          //   className="bg-blue-500 text-white font-bold py-2 px-1 rounded  "
          //   onClick={()=>handleRemove(ad[0])}
          // >
          // Remove
          // </button>:''
          <div
            style={{
              color: "red",
              // size: "50px",
              marginTop: "6px",
              fontSize: "36px",
              cursor: "pointer",
            }}
            onClick={() => handleRemove(ad[0])}
          >
            <AiFillCloseCircle />
          </div>
        ) : (
          ""
        )}

        {/* ----------------------------------------------------------------------------------------- */}
        <div className="col-span-4">
          {ad[1] === "facebook"
            ? facebook
            : ad[1] === "instagram"
              ? instagram
              : ad[1] === "whatsappNumber"
                ? whatsappNumber
                : ad[1] === "linkedin"
                  ? linkedin
                  : ad[1] === "twitter"
                    ? twitter
                    : ad[1] === "youtube"
                      ? youtube
                      : ad[1] === "tiktok"
                        ? tiktok
                        : ad[1] === "snapchat"
                          ? snapchat
                          : ad[1] === "skype"
                            ? skype
                            : ad[1] === "companyProfile"
                              ? companyProfile
                              : ""}
        </div>
        {ad.length > 1 ? (
          <div
            style={{
              color: "red",
              // size: "50px",
              marginTop: "6px",
              fontSize: "36px",
              cursor: "pointer",
            }}
            onClick={() => handleRemove(ad[1])}
          >
            <AiFillCloseCircle />
          </div>
        ) : (
          ""
        )}
        {/* ----------------------------------------------------------------------------------------- */}
        <div className="col-span-4">
          {ad[2] === "facebook"
            ? facebook
            : ad[2] === "instagram"
              ? instagram
              : ad[2] === "whatsappNumber"
                ? whatsappNumber
                : ad[2] === "linkedin"
                  ? linkedin
                  : ad[2] === "twitter"
                    ? twitter
                    : ad[2] === "youtube"
                      ? youtube
                      : ad[2] === "tiktok"
                        ? tiktok
                        : ad[2] === "snapchat"
                          ? snapchat
                          : ad[2] === "skype"
                            ? skype
                            : ad[2] === "companyProfile"
                              ? companyProfile
                              : ""}
        </div>
        {ad.length > 2 ? (
          <div
            style={{
              color: "red",
              // size: "50px",
              marginTop: "6px",
              fontSize: "36px",
              cursor: "pointer",
            }}
            onClick={() => handleRemove(ad[2])}
          >
            <AiFillCloseCircle />
          </div>
        ) : (
          ""
        )}
        {/* ----------------------------------------------------------------------------------------- */}
        <div className="col-span-4">
          {ad[3] === "facebook"
            ? facebook
            : ad[3] === "instagram"
              ? instagram
              : ad[3] === "whatsappNumber"
                ? whatsappNumber
                : ad[3] === "linkedin"
                  ? linkedin
                  : ad[3] === "twitter"
                    ? twitter
                    : ad[3] === "youtube"
                      ? youtube
                      : ad[3] === "tiktok"
                        ? tiktok
                        : ad[3] === "snapchat"
                          ? snapchat
                          : ad[3] === "skype"
                            ? skype
                            : ad[3] === "companyProfile"
                              ? companyProfile
                              : ""}
        </div>
        {ad.length > 3 ? (
          <div
            style={{
              color: "red",
              // size: "50px",
              marginTop: "6px",
              fontSize: "36px",
              cursor: "pointer",
            }}
            onClick={() => handleRemove(ad[3])}
          >
            <AiFillCloseCircle />
          </div>
        ) : (
          ""
        )}
        {/* ----------------------------------------------------------------------------------------- */}
        <div className="col-span-4">
          {ad[4] === "facebook"
            ? facebook
            : ad[4] === "instagram"
              ? instagram
              : ad[4] === "whatsappNumber"
                ? whatsappNumber
                : ad[4] === "linkedin"
                  ? linkedin
                  : ad[4] === "twitter"
                    ? twitter
                    : ad[4] === "youtube"
                      ? youtube
                      : ad[4] === "tiktok"
                        ? tiktok
                        : ad[4] === "snapchat"
                          ? snapchat
                          : ad[4] === "skype"
                            ? skype
                            : ad[4] === "companyProfile"
                              ? companyProfile
                              : ""}
        </div>
        {ad.length > 4 ? (
          <div
            style={{
              color: "red",
              // size: "50px",
              marginTop: "6px",
              fontSize: "36px",
              cursor: "pointer",
            }}
            onClick={() => handleRemove(ad[4])}
          >
            <AiFillCloseCircle />
          </div>
        ) : (
          ""
        )}
        {/* ----------------------------------------------------------------------------------------- */}
        <div className="col-span-4">
          {ad[5] === "facebook"
            ? facebook
            : ad[5] === "instagram"
              ? instagram
              : ad[5] === "whatsappNumber"
                ? whatsappNumber
                : ad[5] === "linkedin"
                  ? linkedin
                  : ad[5] === "twitter"
                    ? twitter
                    : ad[5] === "youtube"
                      ? youtube
                      : ad[5] === "tiktok"
                        ? tiktok
                        : ad[5] === "snapchat"
                          ? snapchat
                          : ad[5] === "skype"
                            ? skype
                            : ad[5] === "companyProfile"
                              ? companyProfile
                              : ""}
        </div>
        {ad.length > 5 ? (
          <div
            style={{
              color: "red",
              // size: "50px",
              marginTop: "6px",
              fontSize: "36px",
              cursor: "pointer",
            }}
            onClick={() => handleRemove(ad[5])}
          >
            <AiFillCloseCircle />
          </div>
        ) : (
          ""
        )}
        {/* ----------------------------------------------------------------------------------------- */}
        <div className="col-span-4">
          {ad[6] === "facebook"
            ? facebook
            : ad[6] === "instagram"
              ? instagram
              : ad[6] === "whatsappNumber"
                ? whatsappNumber
                : ad[6] === "linkedin"
                  ? linkedin
                  : ad[6] === "twitter"
                    ? twitter
                    : ad[6] === "youtube"
                      ? youtube
                      : ad[6] === "tiktok"
                        ? tiktok
                        : ad[6] === "snapchat"
                          ? snapchat
                          : ad[6] === "skype"
                            ? skype
                            : ad[6] === "companyProfile"
                              ? companyProfile
                              : ""}
        </div>
        {ad.length > 6 ? (
          <div
            style={{
              color: "red",
              // size: "50px",
              marginTop: "6px",
              fontSize: "36px",
              cursor: "pointer",
            }}
            onClick={() => handleRemove(ad[6])}
          >
            <AiFillCloseCircle />
          </div>
        ) : (
          ""
        )}
        {/* ----------------------------------------------------------------------------------------- */}
        <div className="col-span-4">
          {ad[7] === "facebook"
            ? facebook
            : ad[7] === "instagram"
              ? instagram
              : ad[7] === "whatsappNumber"
                ? whatsappNumber
                : ad[7] === "linkedin"
                  ? linkedin
                  : ad[7] === "twitter"
                    ? twitter
                    : ad[7] === "youtube"
                      ? youtube
                      : ad[7] === "tiktok"
                        ? tiktok
                        : ad[7] === "snapchat"
                          ? snapchat
                          : ad[7] === "skype"
                            ? skype
                            : ad[7] === "companyProfile"
                              ? companyProfile
                              : ""}
        </div>
        {ad.length > 7 ? (
          <div
            style={{
              color: "red",
              // size: "50px",
              marginTop: "6px",
              fontSize: "36px",
              cursor: "pointer",
            }}
            onClick={() => handleRemove(ad[7])}
          >
            <AiFillCloseCircle />
          </div>
        ) : (
          ""
        )}
        {/* ----------------------------------------------------------------------------------------- */}
        <div className="col-span-4">
          {ad[8] === "facebook"
            ? facebook
            : ad[8] === "instagram"
              ? instagram
              : ad[8] === "whatsappNumber"
                ? whatsappNumber
                : ad[8] === "linkedin"
                  ? linkedin
                  : ad[8] === "twitter"
                    ? twitter
                    : ad[8] === "youtube"
                      ? youtube
                      : ad[8] === "tiktok"
                        ? tiktok
                        : ad[8] === "snapchat"
                          ? snapchat
                          : ad[8] === "skype"
                            ? skype
                            : ad[8] === "companyProfile"
                              ? companyProfile
                              : ""}
        </div>
        {ad.length > 8 ? (
          <div
            style={{
              color: "red",
              // size: "50px",
              marginTop: "6px",
              fontSize: "36px",
              cursor: "pointer",
            }}
            onClick={() => handleRemove(ad[8])}
          >
            <AiFillCloseCircle />
          </div>
        ) : (
          ""
        )}
        {/* ----------------------------------------------------------------------------------------- */}
        {/* ----------------------------------------------------------------------------------------- */}
        <div className="col-span-4">
          {ad[9] === "facebook"
            ? facebook
            : ad[9] === "instagram"
              ? instagram
              : ad[9] === "whatsappNumber"
                ? whatsappNumber
                : ad[9] === "linkedin"
                  ? linkedin
                  : ad[9] === "twitter"
                    ? twitter
                    : ad[9] === "youtube"
                      ? youtube
                      : ad[9] === "tiktok"
                        ? tiktok
                        : ad[9] === "snapchat"
                          ? snapchat
                          : ad[9] === "skype"
                            ? skype
                            : ad[9] === "companyProfile"
                              ? companyProfile
                              : ""}
        </div>
        {ad.length > 9 ? (
          <div
            style={{
              color: "red",
              // size: "50px",
              marginTop: "6px",
              fontSize: "36px",
              cursor: "pointer",
            }}
            onClick={() => handleRemove(ad[9])}
          >
            <AiFillCloseCircle />
          </div>
        ) : (
          ""
        )}
        {/* ----------------------------------------------------------------------------------------- */}

      </div>
    </div>
  );
};

export default Forms;
